import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { getSkinSnapshot } from "@/lib/skinSnapshots";

/**
 * Displays a cached static snapshot of the given .glb ship. All snapshots are
 * generated by a single shared offscreen Three.js renderer (see skinSnapshots.js),
 * so we never spawn multiple WebGL contexts here — this fixes the shop lag &
 * blank-preview issues that appeared when we had one live renderer per card.
 */
export default function SkinPreview3D({ modelUrl, className = "" }) {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let alive = true;
    setSrc(null); setErr(null);
    getSkinSnapshot(modelUrl)
      .then((url) => { if (alive) setSrc(url); })
      .catch((e) => {
        console.warn("[skin-preview] snapshot failed", modelUrl, e);
        if (alive) setErr("Falha ao carregar");
      });
    return () => { alive = false; };
  }, [modelUrl]);

  return (
    <div className={`relative w-full h-full ${className}`} data-testid="skin-preview-3d">
      {src ? (
        <img
          src={src}
          alt=""
          className="absolute inset-0 w-full h-full object-contain skin-preview-float"
          draggable={false}
        />
      ) : (
        <div className="absolute inset-0 grid place-items-center pointer-events-none">
          {err ? (
            <span className="font-mono text-[9px] tracking-widest text-red-300">{err}</span>
          ) : (
            <Loader2 className="h-5 w-5 text-primary/60 animate-spin" />
          )}
        </div>
      )}
    </div>
  );
}
